import Config from '../../utils/Configuration';
import Utility from '../../utils/Helper';
import * as actionTypes from '../../store/actions/ActionTypes';
import baseService from '../BaseService';

const searchResultsInfo = ({searchStr}) => {
    if (!Config.solrSearch.enable) {
        return false;
    }

    const urlSearchParam = searchStr.trim().split(' ').join(' AND ');
    const url = `/solr/products/select?q=${urlSearchParam}`;
    return fetch(Utility.getAemUrl(url)).then((res) => res.json());
};

export const getSearchResults = (searchStr) => {
    return async (dispatch) => {
        dispatch({type: actionTypes.UPDATE_LAST_SEARCH, payload: searchStr});
        return baseService.serviceRequest(
            {},
            dispatch,
            searchResultsInfo,
            {searchStr},
            actionTypes.UPDATE_SEARCH_RESULTS,
            (res) => {
                return {
                    collection: (res.grouped && res.grouped.collection) || {},
                    spellCheck:
                        (res.spellcheck &&
                            res.spellcheck.suggestions &&
                            res.spellcheck.suggestions.length > 1 &&
                            res.spellcheck.suggestions[1].suggestion.map((item) => item.word)) ||
                        []
                };
            }
        );
    };
};

const suggestedSearchesInfo = ({searchStr}) => {
    if (!Config.solrSearch.enable) {
        return false;
    }

    const url = `/solr/products/suggest?suggest.q=${searchStr}`;
    return fetch(Utility.getAemUrl(url)).then((res) => res.json());
};

const getSuggestedSearchesSuccessResponse = (res, searchStr) => {
    const altSolrSuggester =
        (res.suggest.altSolrSuggester &&
            res.suggest.altSolrSuggester[searchStr] &&
            res.suggest.altSolrSuggester[searchStr].suggestions) ||
        [];
    const solrSuggester =
        (res.suggest.solrSuggester &&
            res.suggest.solrSuggester[searchStr] &&
            res.suggest.solrSuggester[searchStr].suggestions) ||
        [];

    return solrSuggester.concat(altSolrSuggester);
};

export const getSuggestedSearches = (searchStr) => {
    return async (dispatch) => {
        return baseService.serviceRequest(
            {skipLoader: true},
            dispatch,
            suggestedSearchesInfo,
            {searchStr},
            null,
            (res) => getSuggestedSearchesSuccessResponse(res, searchStr)
        );
    };
};

const trendingKeywordsInfo = () => {
    if (!Config.solrSearch.enable) {
        return false;
    }

    const url = '/solr/trending/select';
    return fetch(Utility.getAemUrl(url)).then((res) => res.json());
};

export const getTrendingKeywords = () => {
    return async (dispatch) => {
        return baseService.serviceRequest(
            {},
            dispatch,
            trendingKeywordsInfo,
            {},
            actionTypes.UPDATE_TRENDING_SEARCH,
            (res) => {
                return (res && res.response && res.response.docs[0] && res.response.docs[0].keywords) || [];
            }
        );
    };
};

const searchPromotionsInfo = () => {
    if (!Config.solrSearch.enable) {
        return false;
    }

    const url = '/solr/promotions/select';
    return fetch(Utility.getAemUrl(url)).then((res) => res.json());
};

export const getSearchPromotions = () => {
    return async (dispatch) => {
        return baseService.serviceRequest(
            {},
            dispatch,
            searchPromotionsInfo,
            {},
            actionTypes.UPDATE_SEARCH_PROMOTIONS,
            (res) => {
                const docs = (res && res.response && res.response.docs) || [];
                docs.sort((ob1, ob2) => (ob1.searchOrder > ob2.searchOrder ? 1 : -1));
                return docs;
            }
        );
    };
};

const requestCommerceSearchSuggestions = () => {
    const url = '/bin/solr/search-suggestion.json';
    return fetch(Utility.getAemUrl(url)).then((res) => res.json());
};

export const getCommerceSearchSuggestions = () => {
    return async (dispatch) => {
        if (!Config.solrSearch.enable) {
            return [];
        }

        return baseService.serviceRequest(
            {},
            dispatch,
            requestCommerceSearchSuggestions,
            {},
            actionTypes.UPDATE_COMMERCE_SEARCH_SUGGESTIONS,
            (res) => res.keywords || []
        );
    };
};
